export const WIZARD_STEP_NAME = 'WIZARD_STEP_NAME'
export const WIZARD_STEP_STORAGE_TIER = 'WIZARD_STEP_STORAGE_TIER'
export const WIZARD_STEP_SUMMARY = 'WIZARD_STEP_SUMMARY'
export const WIZARD_STEP_SUMMARY_DRIVE_ONLY = 'WIZARD_STEP_SUMMARY_DRIVE_ONLY'
export const DRIVE_NAME_MAX_CHARACTERS = 20

export const getStepTitleAndSubtitle = (step: string) => {
  switch (step) {
    case WIZARD_STEP_NAME:
      return {
        title: 'Name your new drive',
        subtitle: 'Or create a random name using shuffle icon below',
      }
    case WIZARD_STEP_STORAGE_TIER:
      return {
        title: 'How much disk space do you need?',
        subtitle: 'You are billed for data spends on all your Cloud Storage at a given period',
      }
    case WIZARD_STEP_SUMMARY:
      return {
        title: 'Summary',
        subtitle:
          'You are about to setup a new Drive and Renderro plan. Please review the information below before finishing.',
      }
    case WIZARD_STEP_SUMMARY_DRIVE_ONLY:
      return {
        title: 'Summary',
        subtitle:
          'You are about to setup a new Drive. Please review the information below before finishing.',
      }

    default:
      return {
        title: '',
        subtitle: '',
      }
  }
}
